import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {

  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from './reducers/auth'
const reducers = combineReducers({
    authReducer,
   
});



const persistConfig = {
    key: "root",
    version: 1,
    storage,
    whitelist: ["authReducer"],
  };
  const persistedReducer = persistReducer(persistConfig, reducers);

  export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  });